export default __webpack_public_path__ + "872fcf4.png";